import {Button, InputBase} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import env from "../../config/env"
import {TIsUrlSaleOrClearance} from "../../models/Request"

export const getSaleClearanceAssetPath = (path: string): string => {
    return `${env.REACT_APP_BLOB_STORAGE_PATH.replace(/\/$/, "")}${path}`
}

export const HiddenLabel = styled("label")`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
`

export const SearchBarContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$saleOrClearance: TIsUrlSaleOrClearance["saleOrClearance"]}>(({theme, $saleOrClearance = "clearance"}) => {
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "4.375rem",
        backgroundColor: theme.colours.components.saleClearance[$saleOrClearance].bannerBackgroundColour,
        width: "100%",
        maxWidth: breakpoints.values.xxl,
        [theme.breakpoints.up(breakpoints.values.xs)]: {
            padding: "0.75rem 1rem",
            marginBottom: "1rem",
        },
        [theme.breakpoints.up(breakpoints.values.lg)]: {
            width: "calc(100% - 2rem)",
            margin: "0 auto",
        },
    }
})

export const SearchBarInnerContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})(({theme}) => {
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "2.875rem",
        width: "100%",
        [theme.breakpoints.up(breakpoints.values.lg)]: {
            width: "35.75rem",
        },
    }
})

export const SaleClearanceImageContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})(({theme}) => {
    return {
        height: "100%",
        marginRight: "0.5rem",
        [theme.breakpoints.down(breakpoints.values.lg)]: {
            marginRight: 0,
            display: "none",
        },
    }
})

export const SaleClearanceForm = styled("form")`
    height: 2.25rem;
    width: 100%;

    ${({theme}) => theme.breakpoints.up(breakpoints.values.lg)} {
        width: 24.25rem;
    }

    display: flex;
    align-items: center;
    position: relative;
    color: ${({theme}) => theme.colours.form.input.color};
    background: ${({theme}) => theme.colours.form.input.focusActive.background};
    border: ${props => `${props.theme.colours.form.input.border} `};
    border-color: ${props =>
        `${props.theme.colours.components.appBar.brandBar.default.tab.default.enabled.borderColor}`};
    border-radius: ${({theme}) => theme.colours.form.input.radius};
`

export const InputContainer = styled(InputBase)`
    width: 100%;
    height: 100%;
    letter-spacing: normal;

    input {
        height: 100%;
        -webkit-tap-highlight-color: transparent;
        margin: 0;
        display: block;
        min-width: 0;
        animation-name: mui-auto-fill-cancel;
        animation-duration: 10ms;
        background-color: ${props => props.theme.colours.form.input.focusActive.background};
        border-radius: ${({theme}) => theme.colours.form.input.radius};
        padding: 0 2.5rem 0 1rem;
        color: ${({theme}) => theme.palette.text.primary};
        font-size: 0.875rem;

        &::-ms-clear {
            display: none;
        }

        ::placeholder {
            color: ${({theme}) => theme.colours.form.input.placeholder};
            opacity: ${({theme}) => (theme.colours.form.input.placeholder ? 1 : null)};
        }

        ${({theme}) => theme.breakpoints.up(breakpoints.values.md)} {
            padding: 0 ${({theme}) => (theme.colours.form.input.radius === "1.25rem" ? "3.125rem" : "3rem")} 0 0.75rem;
        }
    }
`

export const ClearButton = styled("a")`
    width: 1.25rem;
    height: 1.25rem;
    min-width: 1.25rem;
    min-height: 1.25rem;
    right: 2.75rem;
    position: absolute;
    color: ${({theme}) => theme.colours.text.default};
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    ${({theme}) => theme.breakpoints.up(breakpoints.values.md)} {
        margin-right: 0.6rem;
    }
`

export const SubmitButton = styled(Button)`
    && {
        width: 1.25rem;
        height: 1.25rem;
        min-width: 1.25rem;
        min-height: 1.25rem;
        background: transparent;
        padding: 0;
        border: 0;
        transition: none;
        margin-right: 0.6rem;
    }
`
